import {
    Container,
    Typography,
    Box,
    Button,
    Stack,
    Popover,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import { HexColorPicker } from "react-colorful";


export default function TestComponents() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);
    const [color, setColor] = React.useState('#1976d2');
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const open = Boolean(anchorEl);



    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    const handleChange = (newValue) => {
        setColor(newValue);
    }
    // setValue(1234);

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Components</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>
                Color: {color}
                <Button variant="contained" onClick={() => setValue(value + 1)}>Increase Value</Button>

                
                <Button
                    variant="contained"
                    onClick={handleClick}
                    style={{ backgroundColor: color }}
                >
                    Pick Color: {color}
                </Button>

                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Box sx={{ p: 2 }}>
                        <HexColorPicker color={color} onChange={setColor} />
                    </Box>
                </Popover>
                {/* <MuiColorInput format="hex" value={color} onChange={handleChange} /> */}
            </Stack>
        </Container>
    )
}
